import PropTypes from 'prop-types';

function Separator({ kind, size, orient }) {
    let separatorClasses = 'separator';

    // On ajoute la classe *--complete si jamais le séparateur est complet
    // Sinon le séparateur est partiel et on prend en considération l'orientation et la taille demandée
    if(kind === 'complete') {
        separatorClasses += ' separator--complete';
    } else if(orient === 'start') {
        separatorClasses += ` separator--start separator--${size}`;
    } else if(orient === 'end') {
        separatorClasses += ` separator--end separator--${size}`;
    }

    return <div className={separatorClasses}></div>
}

Separator.propTypes = {
    kind: PropTypes.string.isRequired,
    orient: PropTypes.oneOf(['start', 'end']),
    size: PropTypes.oneOf(['x-small', 'small', 'normal', 'large', 'x-large']),
}

export default Separator;
